export const previewRowPercent = ({
    amount,
    percentBase,
}: {
    amount: number | undefined;
    percentBase: number | undefined;
}): number | undefined => {
    if (
        amount === undefined ||
        percentBase === undefined ||
        percentBase === 0
    ) {
        return undefined;
    }
    return (amount / percentBase) * 100;
};
